import TimelineCarousel from "./components/TimelineCarousel";
function App() {
  return (
    <div className="App">
      Carousel
      <TimelineCarousel />
    </div>
  );
}

export default App;
